import React from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonToolbar, ControlLabel, Form, FormControl, FormGroup, HelpBlock, Radio} from 'react-bootstrap';
import {Link} from 'react-router-dom';

const CompanyForm = (props) => {
  return (
    <Form onSubmit={props.onSave}>
      <FormGroup validationState={props.errors && props.errors.name ? 'error' : null} controlId="formHorizontalName">
        <ControlLabel>Name</ControlLabel>
        <FormControl name="name" type="text" placeholder="Name" value={props.preset.name} onChange={props.onChange}/>
        <FormControl.Feedback/>
        {props.errors.name ? <HelpBlock>{props.errors.name}</HelpBlock> : ''}
      </FormGroup>
      <FormGroup>
        <ControlLabel>Primary Aim</ControlLabel>
        <Radio checked={props.preset.primary_aim_id === 1} name="radioGroup" onClick={() => props.onChangeAim(1)}>
          Productivity
        </Radio>
        <Radio checked={props.preset.primary_aim_id === 2} name="radioGroup" onClick={() => props.onChangeAim(2)}>
          Quality
        </Radio>
        <Radio checked={props.preset.primary_aim_id === 3} name="radioGroup" onClick={() => props.onChangeAim(3)}>
          Predictability
        </Radio>
        <Radio checked={props.preset.primary_aim_id === 4} name="radioGroup" onClick={() => props.onChangeAim(4)}>
          Adaptability
        </Radio>
      </FormGroup>
      <FormGroup>
        <ButtonToolbar className={'pull-right'}>
          <Link to="/companies">
            <Button data-cy="cancel-company-edit" className='secondary'>Cancel</Button>
          </Link>
          <Button data-cy="save-company" className='primary' type="submit">Save</Button>
        </ButtonToolbar>
      </FormGroup>
    </Form>
  );
};

CompanyForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeAim: PropTypes.func.isRequired
};

export default CompanyForm;



// WEBPACK FOOTER //
// ./src/components/company/CompanyForm.js